import { DEFAULT_ICONS_PATH, tuiEditingKeys } from '@taiga-ui/core/constants';

/** @deprecated */
function colorFallback(color) {
    switch (color) {
        case 'secondary':
            return 'var(--tui-info-fill)';
        case 'error':
            return 'var(--tui-error-fill)';
        case 'success':
            return 'var(--tui-success-fill)';
        default:
            return `var(--tui-${color || 'base-05'})`;
    }
}

const ITEM_SIZE = 1.5;
const CONTENT_SIZE = 2.5;
function getBorder(hasIcon, hasCleaner = false, hasTooltip = false, hasContent = false) {
    let border = 0;
    if (hasIcon) {
        border += ITEM_SIZE;
    }
    if (hasCleaner) {
        border += ITEM_SIZE;
    }
    if (hasTooltip) {
        border += ITEM_SIZE;
    }
    if (hasContent) {
        border += CONTENT_SIZE;
    }
    return border;
}

function iconsPathFactory(staticPath) {
    const base = staticPath[staticPath.length - 1] === '/' ? staticPath : `${staticPath}/`;
    return name => {
        if (name.startsWith('tuiIcon')) {
            return `${base}${name}.svg#${name}`;
        }
        return DEFAULT_ICONS_PATH(name);
    };
}

/**
 * Check if pressed key is interactive in terms of input field
 */
function isEditingKey(key) {
    return key.length === 1 || tuiEditingKeys.includes(key);
}

function isPresumedHTMLString(candidate) {
    const trimmed = candidate.trim();
    return trimmed.startsWith('<') && trimmed.endsWith('>');
}

const SIZES = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
/**
 * Compares size constants to determine if first size is bigger than the second
 *
 * @param size size that we need to compare
 * @param biggerThanSize size to compare with, 's' by default
 */
function sizeBigger(size, biggerThanSize = 's') {
    return SIZES.indexOf(size) > SIZES.indexOf(biggerThanSize);
}

/**
 * Generated bundle index. Do not edit.
 */

export { colorFallback, getBorder, iconsPathFactory, isEditingKey, isPresumedHTMLString, sizeBigger };

//# sourceMappingURL=taiga-ui-core-utils-miscellaneous.js.map